export default __webpack_public_path__ + "static/media/p10.eaff309b.PNG";